import DocumentPage from "../../../../invoice/DocumentPage";
import { verifactuSimplifiedInvoiceConfig } from "./config";

const VerifactuSimplifiedInvoice = () => (
  <DocumentPage config={verifactuSimplifiedInvoiceConfig} />
);

export default VerifactuSimplifiedInvoice;